import React, { useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FileIcon, UploadIcon, XIcon } from 'lucide-react';
import { ACCEPTED_EXTENSIONS } from './useContactForm';
import { formatFileSize } from '../../../utils/format';
interface FileDropProps {
  files: File[];
  error: string;
  onAdd: (files: FileList | File[]) => void;
  onRemove: (name: string) => void;
}
export function FileDrop({
  files,
  error,
  onAdd,
  onRemove
}: FileDropProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);
  return <div data-id="element-125" data-mp="nbuply7abnvc">
      <p className="mb-2 text-sm font-medium" data-id="element-126" data-mp="nce5l9ddk26q">Cahier des charges, plans 3D</p>
      <div onDragOver={e => {
      e.preventDefault();
      setDragging(true);
    }} onDragLeave={() => setDragging(false)} onDrop={e => {
      e.preventDefault();
      setDragging(false);
      if (e.dataTransfer.files.length) onAdd(e.dataTransfer.files);
    }} className={`flex flex-col items-center justify-center gap-3 border border-dashed px-6 py-8 text-center transition-colors duration-150 sm:flex-row sm:justify-between sm:text-left ${dragging ? 'border-ember bg-ember-soft' : 'border-ink/25 bg-canvas'}`} data-id="element-127" data-mp="ile6pykp3a1l">
        <div className="flex items-center gap-3" data-id="element-128" data-mp="ia1qzau70qcy">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center bg-ink text-white" data-id="element-129" data-mp="i8qm17p0hck9">
            <UploadIcon className="h-4 w-4" aria-hidden data-id="element-130" data-mp="3gt09d7w5y3g9" />
          </span>
          <div data-id="element-131" data-mp="3lr1sttxi44s9">
            <p className="text-[15px] font-medium" data-id="element-132" data-mp="3lqs9uqavixw2">Glissez vos fichiers ici</p>
            <p className="text-sm text-mute" data-id="element-133" data-mp="3qoag28xiaz0d">STEP, OBJ, STL, DWG, PDF, ZIP · 50 Mo max · 5 fichiers</p>
          </div>
        </div>
        <button type="button" onClick={() => inputRef.current?.click()} className="shrink-0 border border-ink px-4 py-2 text-sm font-medium transition-colors duration-150 hover:bg-ink hover:text-white" data-id="element-134" data-mp="3uou8iz74xeg6">
          Parcourir
        </button>
        <input ref={inputRef} type="file" multiple className="sr-only" accept={ACCEPTED_EXTENSIONS.map(e => `.${e}`).join(',')} onChange={e => {
        if (e.target.files) onAdd(e.target.files);
        e.target.value = '';
      }} aria-label="Joindre des fichiers" data-id="element-135" data-mp="36zskxh354aie" />
      </div>

      {error && <p role="alert" className="mt-1.5 text-sm text-ember-dark" data-id="element-136" data-mp="2ne5xz010m7xy">
          {error}
        </p>}

      {files.length > 0 && <ul className="mt-3 divide-y divide-line border border-line" data-id="element-137" data-mp="2j9yaf66amy1b">
          <AnimatePresence initial={false} data-id="element-138" data-mp="2x4qzowbzjsl3">
            {files.map(f => <motion.li key={f.name} initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} transition={{
          duration: 0.18,
          ease: [0.23, 1, 0.32, 1]
        }} className="overflow-hidden" data-id="element-139" data-mp="2sbei365q4m1u">
                <div className="flex items-center gap-3 px-3.5 py-2.5" data-id="element-140" data-mp="f3ws7ramf03t">
                  <FileIcon className="h-4 w-4 shrink-0 text-ember" aria-hidden data-id="element-141" data-mp="jxr9ko2r72zq" />
                  <span className="flex-1 truncate text-sm" data-id="element-142" data-mp="66cp0ct76tqk">{f.name}</span>
                  <span className="font-mono text-xs text-mute" data-id="element-143" data-mp="b3mkoa76k1mu">{formatFileSize(f.size)}</span>
                  <button type="button" onClick={() => onRemove(f.name)} aria-label={`Retirer ${f.name}`} className="flex h-7 w-7 items-center justify-center text-mute transition-colors duration-150 hover:bg-canvas hover:text-ink" data-id="element-144" data-mp="yt7a9bxu9x53">
                    <XIcon className="h-4 w-4" data-id="element-145" data-mp="ttckjbpsvdlm" />
                  </button>
                </div>
              </motion.li>)}
          </AnimatePresence>
        </ul>}
    </div>;
}